import { Injectable } from '@angular/core';
import { BusinessActivities } from 'src/models/catalogs';
import {
	Categories,
	CategoryResults,
	QuestionResults,
	Questions,
	Results,
	Subcategories,
	SubcategoryResults
} from 'src/models/interfaces';

@Injectable({
	providedIn: 'root'
})
export class QuestionnaireService {
	/***********************	Preguntas de la categoría A    ***********************/
	/***********************	Subcategoría A1    ***********************/
	question1SubA1: Questions = {
		text: [
			'Ningún material se utiliza en exceso, el producto es materializado adecuadamente.',
			'Alto desperdicio de material, puede reducirse mediante rediseño.',
		],
		viability: false,
		id: 1,
	};
	question2SubA1: Questions = {
		text: [
			'El producto es 100% Biodegradable.',
			'Alto porcentaje de materiales técnicos no biodegradables.',
		],
		viability: false,
		id: 2,
	};
	question3SubA1: Questions = {
		text: [
			'Uso de materiales 100% reciclados.',
			'Alto porcentaje de materiales vírgenes, no utilizan reciclados.',
		],
		viability: false,
		id: 3,
	};
	question4SubA1: Questions = {
		text: [
			'No se utilizan materiales escasos en el producto.',
			'Materiales escasos en el producto. Por ejemplo, Antinomia, Cobalto, Galio, Geranio, Indio, Platino, Paladio, Niobio, Neodimio y Tantalio, u otros escasos local y regionalmente.',
		],
		viability: false,
		id: 4,
	};
	question5SubA1: Questions = {
		text: [
			'Los materiales son altamente eco-eficientes (poca energía y emisiones de carbono bajas para su producción).',
			'Los materiales utilizados tienen poca eco-eficiencia.',
		],
		viability: false,
		id: 5,
	};
	question6SubA1: Questions = {
		text: [
			'No hay materiales tóxicos en el producto.',
			'Hay materiales tóxicos en exceso en el producto.',
		],
		viability: false,
		id: 6,
	};
	question7SubA1: Questions = {
		text: [
			'Producción con cero residuos; todos los residuos son re-utilizados.',
			'Desperdicios significativos enviados al vertedero desde la fábrica.',
		],
		viability: false,
		id: 7,
	};
	/***********************	Subcategoría A2    ***********************/
	question8SubA2: Questions = {

		text: [
			'Raramente ocurren fallas en el producto.',
			'Las fallas en el producto son frecuentes.',
		],
		viability: false,
		id: 8,
	};
	question9SubA2: Questions = {
		text: [
			'El producto tiene una vida útil muy larga (mayor a 5 años).',
			'El producto tiene una vida útil muy corta (menor a 5 años).',
		],
		viability: false,
		id: 9,
	};
	question10SubA2: Questions = {
		text: [
			'El producto no usa o tiene un uso teóricamente mínimo de energía o recursos para su funcionamiento.',
			'El producto desperdicia energía y/o recursos para su funcionamiento.',
		],
		viability: false,
		id: 10,
	};
	/***********************	Subcategoría A3    ***********************/
	question11SubA3: Questions = {
		text: [
			'Los costos de reparación son bajos en comparación con el costo de producción.',
			'Los costos de reparación del producto principal a lo largo de su vida útil sobrepasan el costo de producción.',
		],
		viability: false,
		id: 11,
	};
	question12SubA3: Questions = {
		text: [
			'Se ofrece servicio de mantenimiento o reparación adecuado  (podría incluir: reparación, servicio, repuestos de partes, diagnóstico, soporte técnico, instalación y garantía).',
			'Servicio de mantenimiento o reparación no es ofrecido.',
		],
		viability: false,
		id: 12,
	};
	question13SubA3: Questions = {

		text: [
			'Fácil acceso a trabajos internos de mantenimiento y reparación.',
			'Difícil acceso a trabajos internos de mantenimiento y reparación.',
		],
		viability: true,
		id: 13,
	};
	question14SubA3: Questions = {
		text: [
			'Trabajos de mantenimiento o reparación sencillos, fáciles de entender.',
			'Trabajos de mantenimiento o reparación son complejos, difíciles de entender.',
		],
		viability: true,
		id: 14,
	};
	question15SubA3: Questions = {
		text: [
			'Todos los componentes, conectores, módulos o cables son estandarizados.',
			'Componentes, conectores, módulos o cables no estandarizados.',
		],
		viability: false,
		id: 15,
	};
	question16SubA3: Questions = {
		text: [
			'Es fácil hallar fallas.',
			'Es difícil hallar fallas de funcionamiento.',
		],
		viability: true,
		id: 16,
	};
	/***********************	Subcategoría A4    ***********************/
	question17SubA4: Questions = {
		text: [
			'Buen mercado para ventas de segunda mano.',
			'No hay mercado para ventas de segunda mano.',
		],
		viability: true,
		id: 17,
	};
	question18SubA4: Questions = {
		text: [
			'Se ofrecen ampliamente ventas de segunda mano.',
			'Actualmente no se ofrecen ventas de segunda mano.',
		],
		viability: false,
		id: 18,
	};
	question19SubA4: Questions = {
		text: [
			'El producto tiene una vida útil suficientemente larga para su reúso, redistribución o reventa.',
			'El producto tiene una vida útil muy corta para su reúso, redistribución o reventa.',
		],
		viability: true,
		id: 19,
	};
	/***********************	Subcategoría A5    ***********************/
	question20SubA5: Questions = {
		text: [
			'Bajos costos de remanufactura o reacondicionamiento.',
			'Altos costos de remanufactura o reacondicionamiento.',
		],
		viability: true,
		id: 20,
	};
	question21SubA5: Questions = {
		text: [
			'Bajos costos de recolección para devolver el producto a la fábrica.',
			'Altos costos de recolección para devolver el producto a la fábrica.',
		],
		viability: true,
		id: 21,
	};
	question22SubA5: Questions = {
		text: [
			'Todos los productos son devueltos y remanufacturados o reacondicionados.',
			'Actualmente no se cuenta con remanufactura o reacondicionado.',
		],
		viability: false,
		id: 22,
	};
	question23SubA5: Questions = {
		text: ['Fácil de desarmar.', 'Difícil de desarmar.'],
		viability: true,
		id: 23,
	};
	question24SubA5: Questions = {
		text: [
			'Se causa daño significativo al producto o a la parte al desarmar.',
			'No hay daño al producto o a la parte al desarmar.',
		],
		viability: false,
		id: 24,
	};
	question25SubA5: Questions = {
		text: [
			'Es imposible identificar las partes una vez desarmado.',
			'Es fácil identificar las partes una vez desarmado.',
		],
		viability: false,
		id: 25,
	};
	question26SubA5: Questions = {
		text: [
			'No hay piezas modulares, lo que evita que entren o salgan.',
			'Muchas partes son modulares, lo que permite cambiar.',
		],
		viability: true,
		id: 26,
	};
	question27SubA5: Questions = {
		text: [
			'Es posible mejorar las partes.',
			'Es imposible mejorar las partes.',
		],
		viability: true,
		id: 27,
	};
	question28SubA5: Questions = {
		text: [
			'Hay muchas conexiones mecánicas. Por ejemplo, soldaduras, tornillos, remaches, etc.',
			'Hay pocas conexiones mecánicas.',
		],
		viability: true,
		id: 28,
	};
	question29SubA5: Questions = {
		text: [
			'Se requiere de muchas herramientas especializadas para el desarmado.',
			'Se requiere de pocas herramientas especializadas para el desarmado.',
		],
		viability: false,
		id: 29,
	};
	/***********************	Subcategoría A6    ***********************/
	question30SubA6: Questions = {
		text: [
			'Hay buen mercado para vender el producto como servicio.',
			'No hay mercado para vender el producto como un servicio (ejemplo: arrendamiento, tiempo compartido, servicios de proveeduría a largo plazo).',
		],
		viability: false,
		id: 30,
	};
	question31SubA6: Questions = {
		text: [
			'Todos los productos ya se venden como servicio.',
			'Actualmente, ningún producto se vende como servicio.',
		],
		viability: false,
		id: 31,
	};
	/***********************	Subcategoría A7    ***********************/
	question32SubA7: Questions = {
		text: [
			'Hay una baja combinación de materiales en el producto.',
			'Existen muchas combinaciones de materiales en el producto.',
		],
		viability: true,
		id: 32,
	};
	question33SubA7: Questions = {
		text: [
			'Sin materiales encubiertos (por ejemplo, materiales  fáciles de separar para el reciclaje).',
			'Muchos materiales encubiertos o revestidos de difícil separación.',
		],
		viability: false,
		id: 33,
	};

	subcategoryA1: Subcategories = {
		title: 'Diseño, manufactura y distribución',
		questions: [
			this.question1SubA1,
			this.question2SubA1,
			this.question3SubA1,
			this.question4SubA1,
			this.question5SubA1,
			this.question6SubA1,
			this.question7SubA1,
		],
		score: 14,
		id: 1,
	};

	subcategoryA2: Subcategories = {
		title: 'Uso (por el consumidor)',
		questions: [
			this.question8SubA2,
			this.question9SubA2,
			this.question10SubA2,
		],
		score: 6,
		id: 2,
	};

	subcategoryA3: Subcategories = {
		title: 'Reparación y mantenimiento del producto',
		questions: [
			this.question11SubA3,
			this.question12SubA3,
			this.question13SubA3,
			this.question14SubA3,
			this.question15SubA3,
			this.question16SubA3,
		],
		viability: true,
		score: 12,
		id: 3,
	};

	subcategoryA4: Subcategories = {
		title: 'Reúso, redistribución, re-venta del producto',
		questions: [
			this.question17SubA4,
			this.question18SubA4,
			this.question19SubA4,
		],
		viability: true,
		score: 9,
		id: 4,
	};

	subcategoryA5: Subcategories = {
		title: 'Remanufactura o reacondicionamiento del producto o parte de él',
		questions: [
			this.question20SubA5,
			this.question21SubA5,
			this.question22SubA5,
			this.question23SubA5,
			this.question24SubA5,
			this.question25SubA5,
			this.question26SubA5,
			this.question27SubA5,
			this.question28SubA5,
			this.question29SubA5,
		],
		viability: true,
		score: 10,
		id: 5,
	};

	subcategoryA6: Subcategories = {
		title: 'Producto como servicio',
		questions: [this.question30SubA6, this.question31SubA6],
		viability: true,
		score: 4,
		id: 6,
	};

	subcategoryA7: Subcategories = {
		title: 'Reciclado del producto al final de su vida útil',
		questions: [this.question32SubA7, this.question33SubA7],
		score: 4,
		id: 7,
	};

	categoryA: Categories = {
		title: 'Autodiagnóstico de Ciclo Productivo',
		subcategories: [
			this.subcategoryA1,
			this.subcategoryA2,
			this.subcategoryA3,
			this.subcategoryA4,
			this.subcategoryA5,
			this.subcategoryA6,
			this.subcategoryA7,
		],
		score: 59,
		id: 'A',
	};

	/***********************	Preguntas de la categoría B    ***********************/
	/***********************	Subcategoría B1    ***********************/
	question34SubB1: Questions = {
		text: [
			'El origen del agua potable que consume proviene de reúso, tratamiento, etc. ',
			'El origen del agua potable que consume proviene de un cuerpo de agua (lagunas, esteros, lagos, ríos, manantiales), pozos o red de abastecimiento municipal.',
		],
		viability: false,
		id: 34,
	};
	question35SubB1: Questions = {
		text: [
			'Se cuenta con programas de ahorro de agua: reúso, descarga cero, reducción del volumen de aguas residuales.',
			'No contamos con ningún programa de ahorro de agua.',
		],
		viability: false,
		id: 35,
	};
	question36SubB1: Questions = {
		text: [
			'Se realizan actividades de autorregulación para prevenir y controlar las fugas o contaminación del agua.',
			'No se realizan actividades o hay alguna área encargada de prevenir y controlar fugas o contaminación del agua.',
		],
		viability: false,
		id: 36,
	};
	question37SubB1: Questions = {
		text: [
			'Se realiza mantenimiento periódico a sus instalaciones hidráulicas.',
			'No se cuenta con algún plan mantenimiento periódico a sus instalaciones hidráulicas.',
		],
		viability: false,
		id: 37,
	};
	question38SubB1: Questions = {
		text: [
			'Se conoce el destino de las descargas de sus aguas residuales.',
			'No se conoce.',
		],
		viability: false,
		id: 38,
	};
	question39SubB1: Questions = {
		text: [
			'Cuenta con Planta de Tratamiento  de Aguas Residuales o no es necesaria por su bajo uso de agua sin ningún contaminante importante.',
			'No cuenta con Planta de Tratamiento de Aguas y se considera una oportunidad tenerla.',
		],
		viability: false,
		id: 39,
	};
	question40SubB1: Questions = {
		text: [
			'Los lodos de la Planta de Tratamiento son tratados, gestionados o confinados adecuadamente. Los lodos son utilizados para generar biogás.',
			'Los lodos no son tratados, no se sabe si cuentan con concentración no permisibles de sustancias peligrosas y son dispuestos como residuos.',
		],
		viability: false,
		id: 40,
	};
	question41SubB1: Questions = {
		text: [
			'La empresa lleva a cabo procesos de simbiosis industrial, tratamiento y reúso en el sitio de agua. '+
			'(La simbiosis industrial es uso que hace una empresa del material residual de otra; es decir, los desechos '+
			'de una compañía se convierten en insumos productivos para otra).',
			'No se llevan a cabo procesos de simbiosis industrial en materia de agua.',
		],
		viability: false,
		id: 41,
	};
	/***********************	Subcategoría B2    ***********************/
	question42SubB2: Questions = {
		text: [
			'Se tienen identificadas todas las fuentes de generación de residuos (comedor, residuos provenientes de los procesos de producción, sanitarios, etc.).',
			'No se tienen identificadas las fuentes de generación de residuos.',
		],
		viability: false,
		id: 42,
	};
	question43SubB2: Questions = {
		text: [
			'Conoce y/o monitorea las cantidades generadas en cada fuente.',
			'No se contabilizan o monitorean los residuos.',
		],
		viability: false,
		id: 43,
	};
	question44SubB2: Questions = {
		text: [
			'Se cuenta con caracterización de sus residuos sólidos peligrosos y no peligrosos.',
			'No hemos realizado una caracterización de los residuos sólidos peligrosos.',
		],
		viability: false,
		id: 44,
	};
	question45SubB2: Questions = {
		text: [
			'Cuenta con un Plan de Manejo de Residuos Sólidos, autorizado ante' +
			' la autoridad correspondiente, que incluye todos sus residuos.',
			'No cuenta con un plan o este no incluye todos los residuos.',
		],
		viability: false,
		id: 45,
	};
	question46SubB2: Questions = {
		text: [
			'Cuenta con programas de minimizar, reusar o reciclar sus residuos sólidos.',
			'Cuenta con programas de reúso o reciclaje de residuos sólidos.',
		],
		viability: false,
		id: 46,
	};
	question47SubB2: Questions = {
		text: [
			'Mantiene procedimientos de separación primaria de residuos.',
			'No se separa los residuos.',
		],
		viability: false,
		id: 47,
	};
	question48SubB2: Questions = {
		text: [
			'La disposición final de sus residuos sólidos la realiza por medio de un servicio gratuito de recolección.',
			'Cuenta con un servicio externo de manejo de resiudos y tiene un costo.',
		],
		viability: false,
		id: 48,
	};
	question49SubB2: Questions = {
		text: [
			'Mantiene procedimientos de separación primaria de basura y de residuos de proceso.',
			'No se seprara la basura ni residuos de procesos.',
		],
		viability: false,
		id: 49,
	};
	question50SubB2: Questions = {
		text: [
			'Sus residuos peligrosos, son manejados separada y adecuadamente, no se mezclan con aquellos que sean incompatibles entre sí y tienen un proceso de confinamiento adecuado.',
			'No se cuenta con un sistema de gestión de residuos peligrosos.',
		],
		viability: false,
		id: 50,
	};
	question51SubB2: Questions = {
		text: [
			'Realiza simbiosis industrial y reciclaje en el sitio de materiales sólidos: La simbiosis ' +
			'industrial es el intercambio físico de materiales o energía entre empresas; los desechos de una compañía se convierten en el recurso para otra.',
			'No se llevan a cabo procesos de simbiosis industrial para el intercambio de materiales.',
		],
		viability: false,
		id: 51,
	};
	question52SubB2: Questions = {
		text: [
			'Hay un programa para valorizar los residuos, se separan y se venden.',
			'No se valoriza ningún tipo de residuo en el mercado.',
		],
		viability: false,
		id: 52,
	};

	/***********************	Subcategoría B3    ***********************/
	question53SubB3: Questions = {
		text: [
			'Conoce sus requerimientos energéticos como: consumo de electricidad, vapor, combustibles para el transporte, otros combustibles.',
			'No monitoreamos los consumos energéticos.',
		],
		viability: false,
		id: 53,
	};
	question54SubB3: Questions = {
		text: [
			'Todas las fuentes energéticas que utilizamos son renovables (biocombustiles, biogas, energía solar o eólica).',
			'Consumimos en su mayoría energéticos fósiles.',
		],
		viability: false,
		id: 54,
	};
	question55SubB3: Questions = {
		text: [
			'Se cuenta con proyectos de ahorro de energía y uso eficiente de los energéticos.',
			'No se han realizado medidas de conservación o uso eficiente de la energía.',
		],
		viability: false,
		id: 55,
	};
	question56SubB3: Questions = {
		text: [
			'La empresa cuenta con un sistema de gestión y monitoreo de todas las fuentes energéticas que se emplean.',
			'La empresa no cuenta con un sistema de gestión, monitoreo y seguimiento de las fuentes energéticas.',
		],
		viability: false,
		id: 56,
	};
	question57SubB3: Questions = {
		text: [
			'La empresa cuenta con procesos de simbiosis industrial en materia energética.',
			'La empresa no cuenta con procesos de simbiosis industrial en materia energética.',
		],
		viability: false,
		id: 57,
	};
	/***********************	Subcategorías y categoría B    ***********************/

	subcategoryB1: Subcategories = {
		title: 'Agua',
		questions: [
			this.question34SubB1,
			this.question35SubB1,
			this.question36SubB1,
			this.question37SubB1,
			this.question38SubB1,
			this.question39SubB1,
			this.question40SubB1,
			this.question41SubB1,
		],
		score: 16,
		id: 1,
	};
	subcategoryB2: Subcategories = {
		title: 'Residuos sólidos',
		questions: [
			this.question42SubB2,
			this.question43SubB2,
			this.question44SubB2,
			this.question45SubB2,
			this.question46SubB2,
			this.question47SubB2,
			this.question48SubB2,
			this.question49SubB2,
			this.question50SubB2,
			this.question51SubB2,
			this.question52SubB2,
		],
		score: 14,
		id: 2,
	};

	subcategoryB3: Subcategories = {
		title: 'Energía',
		questions: [
			this.question53SubB3,
			this.question54SubB3,
			this.question55SubB3,
			this.question56SubB3,
			this.question57SubB3,
		],
		score: 10,
		id: 3,
	};

	categoryB: Categories = {
		title: 'Materiales y servicios auxiliares',
		subcategories: [
			this.subcategoryB1,
			this.subcategoryB2,
			this.subcategoryB3,
		],
		score: 40,
		id: 'B',
	};

	/***********************	Preguntas de la categoría C    ***********************/
	/***********************	Subcategoría C1    ***********************/
	question58SubC1: Questions = {
		text: [
			'Conoce el concepto de economía circular.',
			'No estoy familiarizado con el concepto de economía circular.',
		],
		viability: false,
		id: 58,
	};
	question59_1SubC1: Questions = {
		text: [
			'Conoce sobre la aplicación de Simbiosis Industrial.',
		],
		viability: false,
		options: [
			'Mucho',
			'Poco',
			'Nada'
		],
		id: 59,
	};
	question59_2SubC1: Questions = {
		text: [
			'Conoce o ha aplicado una evaluación de Ciclo de Vida de Producto.',
		],
		viability: false,
		options: [
			'Mucho',
			'Poco',
			'Nada'
		],
		id: 59,
	};
	question59_3SubC1: Questions = {
		text: [
			'Conoce sobre la aplicación de reúso, reciclaje, remanufactura y reacondicionamiento.',
		],
		viability: false,
		options: [
			'Mucho',
			'Poco',
			'Nada'
		],
		id: 59,
	};
	question60SubC1: Questions = {
		text: [
			'Se ha recibido en su empresa alguna asesoría o capacitación por profesionales sobre economía circular.',
			'No se han recibido alguna tipo asesoría o capacitación en  el tema.',
		],
		viability: false,
		id: 60,
	};

	/***********************	Subcategoría C2    ***********************/
	question61SubC2: Questions = {
		text: [
			'Adopta su empresa principios de economía circular, como rediseño, uso optimo de los materiales, reciclaje, remanufactura, etc.',
			'No se adoptan principios de economía circular.',
		],
		viability: false,
		id: 61,
	};
	question6SubC2: Questions = {
		text: [
			'Cuenta con políticas o planes de acción (gestión) sobre economía circular.',
			'La empresa no cuenta con ninguna política o plan de acción relacionada. ',
		],
		viability: false,
		id: 62,
	};
	question63SubC2: Questions = {
		text: [
			'La empresa cuenta con una política y programas que favorecen e incentivan acciones de economía circular.',
			'Existen normas o políticas que obstaculizan la implementación de acciones de economía circular.',
		],
		viability: true,
		id: 63,
	};
	question64SubC2: Questions = {
		text: [
			'Consideraría fácil modificar, actualizar o proponer nuevas políticas en la materia.',
			'No se considera fácil introducir el tema a las políticas de la empresa.',
		],
		viability: true,
		id: 64,
	};
	question65SubC2: Questions = {
		text: [
			'En los sistemas de gestión o evaluación se cuenta con métricas e indicadores específicos para evaluar temas relacionados a la economía circular, ejemplo, intensidad del uso de recursos por unidad de producto, cantidad de residuos o recirculación de materiales, cantidad de mermas, etc.',
			'No se cuentan con métricas o indicadores relacionados.',
		],
		viability: false,
		id: 65,
	};
	question66SubC2: Questions = {
		text: [
			'Existe interés desde la dirección de promover acciones e iniciativas de economía circular o sostenibilidad.',
			'No existe interés desde el nivel directivo.',
		],
		viability: false,
		id: 66,
	};
	question67SubC2: Questions = {
		text: [
			'Existe en la empresa algún rol individual (cargo o puesto oficial) o consejo responsable de abordar la economía circular.',
			'No existen responsables del tema.',
		],
		viability: true,
		id: 67,
	};
	question68SubC2: Questions = {
		text: [
			'El personal responsable esta  capacitado o cuenta con credenciales en el tema.',
			'No se considera que el personal cuente con capacitación adecuada.',
		],
		viability: false,
		id: 68,
	};
	/***********************	Subcategoría C3    ***********************/
	question69SubC3: Questions = {
		text: [
			'Los procesos productivos y de operación adoptan acciones de economía circular.',
			'Los procesos y procedimientos son lineales en su mayoría.',
		],
		viability: false,
		id: 69,
	};
	question70SubC3: Questions = {
		text: [
			'No existen obstáculos para adoptar actividades de economía circular.',
			'Existen obstáculos en la operación para adoptar la economía circular.',
		],
		viability: false,
		id: 70,
	};
	question71SubC3: Questions = {
		text: [
			'Es fácil actualizar o modificar los procedimientos, en términos prácticos y tecnológicos, hacia una economía circular.',
			'Parece de gran dificultad actualizar o modificar procesos técnicos o tecnológicos hacia una economía circular.',
		],
		viability: false,
		id: 71,
	};
	question72SubC3: Questions = {
		text: [
			'El personal puede participar con ideas y propuestas para integrar más procedimientos o procesos al esquema de economía circular.',
			'No existe un mecanismo para proponer iniciativas de economía circular.',
		],
		viability: false,
		id: 72,
	};
	question73SubC3: Questions = {
		text: [
			'Existe una cartera de proyectos de economía circular y se le da seguimiento.',
			'No contamos con proyectos o iniciativas, o no se les da seguimiento.',
		],
		viability: false,
		id: 73,
	};
	/***********************	Subcategoría C4    ***********************/
	question74SubC4: Questions = {
		text: [
			'Se cuenta con proveedores o socios industriales para implementar mecanismos de economía circular y/o simbiosis industrial.',
			'No se cuenta con proveedores o socios relacionados o interesados.',
		],
		viability: false,
		id: 74,
	};
	question75SubC4: Questions = {
		text: [
			'Conoce proveedores de tecnologías o soluciones que lo apoyen en implementar medidas de economía circular.',
			'No cuenta con proveedores identificados.',
		],
		viability: false,
		id: 75,
	};
	question76SubC4: Questions = {
		text: [
			'Es fácil contactar socios o proveedores potenciales para implementar medidas en la materia (ejemplo, a través de redes empresariales, clusters, parque industrial, etc.).',
			'No considera fácil encontrar actores en su ecosistema.',
		],
		viability: false,
		id: 76,
	};
	question77SubC4: Questions = {
		text: [
			'No existe gran valor en generar alianzas con externos.',
			'Reconoce un gran potencial de generar valor a través de alianzas para implementar economía circular.',
		],
		viability: false,
		id: 77,
	};
	/***********************	Subcategoría C5    ***********************/
	question78SubC5: Questions = {
		text: [
			'¿Los clientes son o pueden ser parte del esquema de la economía circular de la empresa?',
		],
		options: [
			'Sí',
			'Probablemente',
			'No'
		],
		viability: false,
		id: 78,
	};
	question79SubC5: Questions = {
		text: [
			'¿Qué tanto valor agrega a los clientes contar con esquemas de economía circular?',
		],
		options: [
			'Mucho',
			'Poco',
			'Nada'
		],
		viability: false,
		id: 79,
	};
	question80SubC5: Questions = {
		text: [
			'Podría ganar clientes al agregar esquemas, procedimientos o políticas de economía circular.',
		],
		options: [
			'Sí',
			'Probablemente',
			'No'
		],
		viability: false,
		id: 80,
	};
	question81SubC5: Questions = {
		text: [
			'Considera positivo transitar a una economía circular, en ventas, imagen, regulación, percepción de inversionistas, etc.',
		],
		options: [
			'Sí, mucho',
			'Poco',
			'No'
		],
		viability: false,
		id: 81,
	};
	question82SubC5: Questions = {
		text: [
			'Recibe iniciativas de sus clientes sobre  economía circular relacionado a sus productos o servicios.',
		],
		options: [
			'Sí',
			'Algunas',
			'No'
		],
		viability: false,
		id: 82,
	};

	/***********************	Subcategorías y categoría C    ***********************/
	subcategoryC1: Subcategories = {
		title: 'Conocimiento general',
		questions: [
			this.question58SubC1,
			this.question59_1SubC1,
			this.question59_2SubC1,
			this.question59_3SubC1,
			this.question60SubC1,
		],
		score: 10,
		id: 1,
	};
	subcategoryC2: Subcategories = {
		title: 'Política interna y plan de gestión',
		questions: [
			this.question61SubC2,
			this.question6SubC2,
			this.question63SubC2,
			this.question64SubC2,
			this.question65SubC2,
			this.question66SubC2,
			this.question67SubC2,
			this.question68SubC2,
		],
		viability: true,
		score: 10,
		id: 2,
	};
	subcategoryC3: Subcategories = {
		title: 'Adopción',
		questions: [
			this.question69SubC3,
			this.question70SubC3,
			this.question71SubC3,
			this.question72SubC3,
			this.question73SubC3,
		],
		score: 10,
		id: 3,
	};
	subcategoryC4: Subcategories = {
		title: 'Proveedores y socios industriales',
		questions: [
			this.question74SubC4,
			this.question75SubC4,
			this.question76SubC4,
			this.question77SubC4,
		],
		score: 8,
		id: 4,
	};
	subcategoryC5: Subcategories = {
		title: 'Clientes',
		questions: [
			this.question78SubC5,
			this.question79SubC5,
			this.question80SubC5,
			this.question81SubC5,
			this.question82SubC5,
		],
		score: 10,
		id: 5,
	};

	categoryC: Categories = {
		title: 'Gestión interna y ecosistema de la Economía Circular',
		subcategories: [
			this.subcategoryC1,
			this.subcategoryC2,
			this.subcategoryC3,
			this.subcategoryC4,
			this.subcategoryC5,
		],
		score: 48,
		id: 'C',
	};

	constructor() {
	}

	public newResults(userId: string, businessActivity: number) {
		const skipCatA = (businessActivity == BusinessActivities.services);
		const questionnaire = this.getQuestionnaire(skipCatA);
		const catRes: CategoryResults[] = [];
		let sum = 0;
		questionnaire.forEach((category: Categories) => {
			const subcategoriesRes: SubcategoryResults[] = [];
			category.subcategories.forEach((subcategory: Subcategories) => {
				const questionRes: QuestionResults[] = [];
				subcategory.questions.forEach((question: Questions) => {
					questionRes.push({
						id: question.id,
						score: 2
					});
				});
				subcategoriesRes.push({
					id: subcategory.id,
					score: subcategory.score,
					questions: questionRes
				});
			});
			catRes.push({
				id: category.id,
				score: category.score,
				subcategories: subcategoriesRes
			});
			sum += category.score;
		});
		const results: Results = {
			score: sum,
			userId: userId,
			categories: catRes
		}
		return {
			questionnaire: questionnaire,
			results: results
		};
	}

	getQuestionnaire(skipCatA: boolean): Categories[] {
		return (skipCatA) ? [this.categoryB, this.categoryC] : [this.categoryA, this.categoryB, this.categoryC];
	}
}
